import React, { useState,useEffect } from 'react';
import { Card,Accordion,Placeholder } from 'react-bootstrap';
const Facilities = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Facilities,setFacilities]=useState([]);
    useEffect(()=>
    {
        const FacilitiesAtUniversity = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"departmentLabs/facilitiesAtUniversity");
                const result = await response.json();
                setFacilities(result);
                if( global.config.IsPrint === true ) { console.info('FacilitiesAtUniversity : Result',result); }
            } 
            catch (error)
            {
                console.error('FacilitiesAtUniversity : Error', error.message);                
            }
            finally
            {
                setLoading(false);
            }
        };
        FacilitiesAtUniversity();
    },[])
    return (
        <Card className=' mb-4'>
            <Card.Header className='text-center fs-3 text-uppercase' data-aos="flip-up" data-aos-duration="1000">
                {appLanguage === 'hi' ? 'विश्वविद्यालय में सुविधाएँ' : 'Facilities At University'}
            </Card.Header>
            <Card.Body>
            {isLoading ? (
                <Accordion defaultActiveKey={[0]} alwaysOpen>
                {[...Array(12)].map((_,index)=>(
                    <Accordion.Item eventKey={index} key={index}>
                        <Accordion.Header><Placeholder xs={6} /></Accordion.Header>
                        <Accordion.Body>
                            <Placeholder xs={12} />
                            <Placeholder xs={10} />
                            <Placeholder xs={8} />
                            <Placeholder xs={10} />
                            <Placeholder xs={6} />
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
                </Accordion>
                ) : (
                <Accordion defaultActiveKey={[0]} alwaysOpen>
                {Facilities.map((dl,index)=>(
                    <Accordion.Item eventKey={index} key={index}>
                        <Accordion.Header className='fw-bold'>
                            { appLanguage === 'hi' ? ( dl.dl_display_en === "1" ? dl.dl_name_hi || '' : dl.dl_name_hi || dl.dl_name ) : dl.dl_name }
                        </Accordion.Header>
                        <Accordion.Body dangerouslySetInnerHTML={{__html: appLanguage === 'hi' ? ( dl.dl_display_en === "1" ? dl.dl_details_hi || '' : dl.dl_details_hi || dl.dl_details ) : dl.dl_details}} ></Accordion.Body>
                    </Accordion.Item>
                ))}
                </Accordion>
            )}
            </Card.Body>
        </Card>
    );
}
export default Facilities;